import { Controller } from "react-hook-form";
import { FBasicPropos } from "../../../interfaces/User.interface";
import { InputAdornment, TextField } from "@mui/material";

export const FPhoneField: React.FC<FBasicPropos> = ({
    field,
    control,
    errors,
    props, 
    errorMessage
}) => {
    const { name, editable, icon, inputProps } = field;
    if (!errorMessage) errorMessage = errors[name]?.message as string;

    const formatPhoneNumber = (value: string) => {
        const phoneNumber = value.replace(/\D/g, '').slice(0, 10);
        if (phoneNumber.length > 6) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
        } else if (phoneNumber.length > 3) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        } else if (phoneNumber.length > 0) {
            return `(${phoneNumber}`;
        }
        return '';
    };

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: controllerField }) => {
                const handleNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                    const formattedValue = formatPhoneNumber(event.target.value);
                    controllerField.onChange(formattedValue);
                };

                return (
                    <TextField
                        {...controllerField}
                        value={controllerField.value || ''}
                        type="tel"
                        label={field.question}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        error={!!errors[name] || !!errorMessage}
                        helperText={errorMessage}
                        disabled={editable === false}
                        placeholder={field.question}
                        InputProps={{
                            startAdornment: icon ? (
                                <InputAdornment position="start">
                                    {icon}
                                </InputAdornment>
                            ) : null,
                            ...inputProps,
                        }}
                        onChange={handleNumberChange}
                        {...props}
                    />
                );
            }}
        />
    );
};
